import { LOGISTICS_API_BASE_URL } from "../../../config/apiConfig";

const getLogisticsApiUrl = (path) =>
  `${LOGISTICS_API_BASE_URL.replace(/\/$/, "")}${path}`;

const parseResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return response.json();
  }

  return response.text();
};

const getAuthorizationHeaders = () => {
  const storedTokens = localStorage.getItem("authTokens");

  if (!storedTokens) {
    return {};
  }

  try {
    const authTokens = JSON.parse(storedTokens);

    return authTokens?.access
      ? { Authorization: `Bearer ${authTokens.access}` }
      : {};
  } catch {
    return {};
  }
};

const postLogisticsProgress = async (path, payload, options = {}) => {
  const response = await fetch(getLogisticsApiUrl(path), {
    method: "POST",
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      ...getAuthorizationHeaders(),
      ...options.headers,
    },
    body: JSON.stringify(payload),
    signal: options.signal,
  });

  const data = await parseResponse(response);

  if (!response.ok) {
    // The .NET Logistics service's error middleware responds with
    // { error: "..." }, not { message: "..." } — data?.message here always
    // missed it and silently fell back to the generic text below. Keep
    // .message as a fallback in case some other error shape shows up.
    const message =
      typeof data === "string"
        ? data
        : data?.error || data?.message || "Failed to update logistics progress.";

    throw new Error(message);
  }

  return data;
};

export const updateLogisticsProgress = (payload, options = {}) =>
  postLogisticsProgress("/logistics/progress", payload, options);

export const queryLogisticsProgress = (payload, options = {}) =>
  postLogisticsProgress("/logistics/progress/query", payload, options);
